import '../../sass/blocks/block-latest-news.scss';

const $latestNewsBlocks = document.querySelectorAll(
    '.latest-news-list-wrapper'
);

if ($latestNewsBlocks.length) {
    $latestNewsBlocks.forEach((block) => {
        const toggle = block.querySelector('.show-more-posts-toggle');
        if (toggle) {
            const countPosts = toggle.getAttribute('data-count-posts');
            const postsPerPage = toggle.getAttribute('data-posts-per-page');
            const wrapper = block.querySelector('.latest-news-list');
            const lang = toggle.getAttribute('data-lang');

            toggle.addEventListener('click', async (e) => {
                e.preventDefault();
                let posts = wrapper.querySelectorAll('.post-item-wrapper');
                const formData = new FormData();
                formData.append('action', 'load_more_news');
                formData.append('offset', posts.length);
                formData.append('posts-per-page', postsPerPage);
                formData.append('lang', lang);
                const RESPONSE = await fetch(window.var_from_php.ajax_url, {
                    method: 'POST',
                    body: formData,
                });
                const POSTS = await RESPONSE.json();
                if (POSTS.success) {
                    wrapper.innerHTML += POSTS.data.news;
                    posts = wrapper.querySelectorAll('.post-item-wrapper');
                    if (countPosts <= posts.length) {
                        block.classList.remove('show-more-enabled');
                    }
                }
            });
        }
    });
}
